import moment from 'moment';
import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  actionBusy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.fpg.list = {
      ...state.modulo.fpg.list,
      ...data,
    };
  });
};

const download = async (store, selectedRowKeys) => {
  store.setState((state) => {
    state.modulo.fpg.list.actionBusy = true;
  });

  try {
    const response = await Http.get(`${window.BONJOUR_URL}/api/autofacturacion/fpg`);

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.fpg.list.actionBusy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.fpg.list.actionBusy = false;
      state.modulo.fpg.list.error = error.data || error;
    });
  }
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.fpg.list.data = {
      ...state.modulo.fpg.list.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.fpg.list = {
      ...state.modulo.fpg.list,
      result: undefined,
      error: undefined,
      busy: true,
      pagination: {
        ...state.modulo.fpg.list.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.fpg.list;

    const body = {
      ...pagination,
      ...params,
    };

    const response = await Http.get(`/api/autofacturacion/fpg`, { params: body });

    store.setState((state) => {
      state.modulo.fpg.list = {
        ...state.modulo.fpg.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.fpg.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
        filters: {
          ...state.modulo.fpg.list.filters,
          ...body,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.fpg.list.busy = false;
      state.modulo.fpg.list.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.fpg.list = {
      ...initialState,
    };
  });
};

const FacturasGlobalesListStore = {
  state: () => initialState,
  actions: {
    change,
    download,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default FacturasGlobalesListStore;
